import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ThreeDService } from 'src/app/services/three-d.service';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss'],
})
export class StepTwoComponent implements OnInit {
  constructor(
    private configurationService: ConfigurationService,
    private threeDService: ThreeDService
  ) {}
  allowedWallThicknesses = [];
  selectedThickness = null;

  ngOnInit() {
    this.threeDService.setZoom(3.75);
    this.threeDService.resetDefaultCamera();

    this.configurationService.furthestStepVisited = 2;

    this.allowedWallThicknesses = this.configurationService.allowedWallThicknesses;
    this.selectedThickness =
      this.configurationService.wallThickness || this.configurationService.allowedWallThicknesses[0];
  }

  updateThickness(value: number) {
    this.selectedThickness = value;
    this.configurationService.wallThickness = value;
  }
}
